//IMPORTS
import React from "react";

import "../scss/Contact.scss";

import { employees } from "../constants/employees";
import { ContactCard } from "../components/Contact/ContactCard";

export const Contact = () => {
  //

  return (
    <main className='contact'>
      <div className='container'>
        <section className='flexFlow'>
          <ContactCard employee={employees.denis} />
          <ContactCard employee={employees.mario} />
          <ContactCard employee={employees.filip} />
        </section>
      </div>
    </main>
  );
};
